import React from "react";
import Banner from "./../../components/Banner";
import { Sidebar } from "./../../components/Sidebar";
import Balance from "./Balance";
import AccountStatus from "./AccountStatus";

export const Account = () => {
  const companyProfileId = window.sessionStorage.getItem("companyProfileId");
  const individualProfileId = window.sessionStorage.getItem(
    "individualProfileId"
  );
  const isIndividual = React.useMemo(() => {
    if (!!Number(individualProfileId)) {
      return true;
    }
    if (!!Number(companyProfileId)) {
      return false;
    }
    return false;
  }, [individualProfileId, companyProfileId]);
  return (
    <div className="min-h-screen h-dvh flex justify-between bg-white">
      <Sidebar />
      <div className="min-vh-100 w-100 d-flex flex-column overflow-auto">
        <Banner title="View Account" />
        {isIndividual ? <Balance /> : <AccountStatus />}
        
      </div>
    </div>
  );
};
